import { Injectable } from "@angular/core";
import { BasiqValidator } from "./basiq.validator";
import { SyncStatusEnum } from "@bitwarden/web-vault/app/models/types/general-types";
import { BasiqConnection, BasiqJobType } from "@bitwarden/web-vault/app/models/types/basiq.types";

@Injectable({
  providedIn: "root",
})
export class BasiqInstitutionValidator extends BasiqValidator {
  instoConnection: BasiqConnection;
  job: BasiqJobType;
  syncStatus: SyncStatusEnum;

  /**
   * If valid set instoConnection and job return true
   * otherwise set syncStatus and return false
   * */
  async isValid(instoBasiqId: string) {
    this.appState.startProcess("basiq-syncing-data", "Validating your connections");
    if (!(await this.isValidConnection(instoBasiqId))) {
      this.appState.endProcess("basiq-syncing-data");
      return false;
    }

    const isConnectionRefreshed = await this.isRefreshedConnection();
    this.appState.endProcess("basiq-syncing-data");

    return isConnectionRefreshed;
  }

  /** If there is a connection for the institution set the instoConnection to it and return true
   * otherwise set instoConnection to null, syncStatus to noConnection and return false
   * */
  private async isValidConnection(instoBasiqId: string) {
    try {
      const connectionResponse = await this.basiqAuthApi.accountConnections(instoBasiqId);
      const basiqConnection = connectionResponse?.connections.find(
        (c) => c.institution.id === instoBasiqId,
      );

      if (basiqConnection) {
        this.instoConnection = basiqConnection;

        return true;
      }
      this.instoConnection = null;
      const error = new Error(
        `No connection found for ${instoBasiqId} here is what is returned ${basiqConnection}`,
      );
      await this.glossSyncService.logError(
        [],
        error,
        "basiq connection check",
        SyncStatusEnum.noConnection,
      );
      this.syncStatus = SyncStatusEnum.noConnection;

      return false;
    } catch (error) {
      await this.glossSyncService.logError(
        [],
        error,
        `basiq connection check caught error here is instoBasiqId : ${instoBasiqId}`,
        SyncStatusEnum.noConnection,
      );
      return false;
    }
  }

  /** Refresh the connection. If you get a job back, means it is refreshed otherwise it is not*/
  private async isRefreshedConnection() {
    try {
      const refreshConnection = await this.basiqAuthApi.refreshConnection(this.instoConnection);
      if (!refreshConnection?.job) {
        const error = new Error(
          `Insto refreshing did not return a job. Here is what is returned ${refreshConnection}`,
        );
        await this.glossSyncService.logError(
          [],
          error,
          "institution connection refresh",
          SyncStatusEnum.noConnectionRefresh,
        );
        this.syncStatus = SyncStatusEnum.noConnectionRefresh;
        return false;
      }

      this.job = refreshConnection.job;
      return true;
    } catch (error) {
      this.syncStatus = SyncStatusEnum.noConnectionRefresh;
      await this.glossSyncService.logError(
        [],
        error,
        `institution connection refresh for connection: ${this.instoConnection}`,
        SyncStatusEnum.noConnectionRefresh,
      );
      return false;
    }
  }
}
